(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-product"] && !Shopify.designMode) return;
  try {
    (() => {
  const londonTime = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Europe/London',
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h23'
  });

  const isBeforeCutoff = () => {
    let hour = 0;
    let minute = 0;

    londonTime.formatToParts(new Date()).forEach((part) => {
      if (part.type === 'hour') hour = Number(part.value);
      if (part.type === 'minute') minute = Number(part.value);
    });

    return (hour * 60) + minute < 16 * 60;
  };

  const refreshDeliveryTodayBadges = () => {
    const show = isBeforeCutoff();

    document.querySelectorAll('[data-gardenia-delivery-today]').forEach((badge) => {
      badge.hidden = !show;
      badge.setAttribute('aria-hidden', show ? 'false' : 'true');
    });
  };

  const start = () => {
    refreshDeliveryTodayBadges();

    const delayToNextMinute = 60000 - (Date.now() % 60000) + 50;
    window.setTimeout(() => {
      refreshDeliveryTodayBadges();
      window.setInterval(refreshDeliveryTodayBadges, 60000);
    }, delayToNextMinute);

    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) refreshDeliveryTodayBadges();
    });
    document.addEventListener('shopify:section:load', refreshDeliveryTodayBadges);
    window.addEventListener('pageshow', refreshDeliveryTodayBadges);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gardenia-vase-addon"] && !Shopify.designMode) return;
  try {
    function gardeniaVaseUpdateSummary(addon) {
    if (!addon) return;
    const status = addon.querySelector('[data-gardenia-vase-status]');
    const selected = addon.querySelector('[data-gardenia-vase-choice]:checked');
    if (!status || !selected) return;
    if (selected.dataset.gardeniaVaseKind === 'none') {
      status.textContent = addon.dataset.gardeniaVaseDefault || 'Optional';
    } else {
      status.textContent = (selected.dataset.vaseLabel || '') + ' · ' + (selected.dataset.vasePrice || '');
    }
  }
  document.addEventListener('change', function(event) {
    const selected = event.target.closest('[data-gardenia-vase-choice]');
    if (!selected) return;
    const addon = selected.closest('[data-gardenia-vase-addon]');
    const info = selected.closest('product-info');
    if (!addon || !info) return;
    const desiredValue = selected.dataset.gardeniaVaseKind === 'glass' ? 'Add a glass vase' : 'No glass vase';
    const nativeOption = Array.from(info.querySelectorAll('variant-selects input[data-option-name="Add a glass vase?"]'))
      .find(input => input.value === desiredValue);
    if (nativeOption && !nativeOption.checked) nativeOption.click();
    gardeniaVaseUpdateSummary(addon);
    addon.open = false;
  });
  } catch(e) { console.error(e); }
})();

})();
